export const reviews = [
  {
    id: "r1",
    name: "Chris Brooks",
    meta: "",
    time: "vor 6 Monaten",
    stars: 5,
    text: "Meine fast 6 Meter hohe Hecke wurde von Arnold Gartenpflege sorgfältig und professionell nach meinen Bedürfnissen gekürzt. Das Team kam pünktlich an und erledigte die Arbeiten zügig zu einem fairen Preis. Außerdem wurde mir erklärt, wann und wie ich die Hecke in Zukunft wieder schneiden sollte. Jederzeit wieder!",
  },
  {
    id: "r2",
    name: "Ulrike Gulden",
    meta: "",
    time: "vor 11 Monaten",
    stars: 5,
    text: "",
  },
  {
    id: "r3",
    name: "Barbara G.",
    meta: "Local Guide",
    time: "vor einem Jahr",
    stars: 5,
    text: "Sehr zuverlässige Ausführung der Gartenarbeit, Laub entfernen, Bäume schneiden, Gartenabfall entsorgen. Der Preis wurde transparent aufgezeigt und die Kommunikation war immer schnell und freundlich. Gerne wieder, vielen Dank!",
  },
  {
    id: "r4",
    name: "Elmo",
    meta: "Local Guide",
    time: "vor 6 Monaten",
    stars: 5,
    text: "Sehr kurzfristige Erledigung der Arbeiten (Apfelbaum- und Rosenschnitt)",
  },
  {
    id: "r5",
    name: "Roswitha Gebhardt",
    meta: "",
    time: "vor einem Jahr",
    stars: 5,
    text: "Ich war mit den Arbeiten der Firma Arnold mehr als zufrieden 👍😊 sie sind zuverlässig, kompetent und freundlich, kann ich jedem Gartenbesitzer nur empfehlen! Endlich hat sich für mich die Suche nach guten Gärtnern erledigt, werde in Zukunft nur noch diese Gartenpflege nehmen 🌷🍀 R.G.",
  },
  {
    id: "r6",
    name: "Eberhard Oellrich",
    meta: "",
    time: "vor einem Jahr",
    stars: 5,
    text: "",
  },
  {
    id: "r7",
    name: "Gertraud Rossmann",
    meta: "",
    time: "vor 2 Monaten",
    stars: 5,
    text: "Gute Kommunikation, provisionelle Arbeit, schnell und sauber auch ohne unserer Anwesenheit, gerne wieder. Sehr zu Empfehlen",
  },
  {
    id: "r8",
    name: "Feuersalamander",
    meta: "Local Guide",
    time: "vor 9 Monaten",
    stars: 5,
    text: "Ist gut 👍",
  },
  {
    id: "r9",
    name: "Samantha Gale",
    meta: "",
    time: "vor einem Jahr",
    stars: 5,
    text: "Ein hervorragender Service! Sehr freundlich und schnell, mit exzellenten Ergebnissen. Guter Preis.",
  },
  {
    id: "r10",
    name: "Ludwig Reischl",
    meta: "",
    time: "vor einem Jahr",
    stars: 5,
    text: "Kurzfristige Zusage. Fachgerechter Schnitt der Apfelbäume",
  },
  {
    id: "r11",
    name: "Karl-Heinz Just",
    meta: "",
    time: "vor einem Jahr",
    stars: 5,
    text: "Sehe gute Arbeit gutes Preis leistungs verhältnis",
  },
];